/**
 * DOM helpers — prefer textContent over innerHTML.
 */
export function el(tag, attrs = {}, children = []) {
	const node = document.createElement(tag);
	Object.entries(attrs).forEach(([key, value]) => {
		if (value === null || value === undefined || value === false) {
			return;
		}
		if (key === 'className') {
			node.className = value;
			return;
		}
		if (key === 'text') {
			node.textContent = value;
			return;
		}
		if (key === 'html') {
			node.innerHTML = value;
			return;
		}
		if (key.startsWith('on') && typeof value === 'function') {
			node.addEventListener(key.slice(2).toLowerCase(), value);
			return;
		}
		node.setAttribute(key, value === true ? '' : String(value));
	});

	(Array.isArray(children) ? children : [children]).forEach((child) => {
		if (child === null || child === undefined || child === false) {
			return;
		}
		if (typeof child === 'string') {
			node.appendChild(document.createTextNode(child));
			return;
		}
		node.appendChild(child);
	});

	return node;
}

export function empty(node) {
	while (node.firstChild) {
		node.removeChild(node.firstChild);
	}
	return node;
}

export function qs(selector, root = document) {
	return root.querySelector(selector);
}
